// A new password (views/auth/_password.ejs): tick each rule as it is met, say whether the two
// passwords match, and fill the weak / fair / strong bar. The server checks the same rules.
document.querySelectorAll<HTMLElement>('[data-pw-check]').forEach(box => {
  const form = box.closest('form');
  const input = form?.querySelector<HTMLInputElement>(`input[name="${box.dataset.pwCheck}"]`);
  if (!form || !input) return;
  const confirm = box.dataset.pwConfirm ? form.querySelector<HTMLInputElement>(`input[name="${box.dataset.pwConfirm}"]`) : null;
  const meter = box.querySelector<HTMLElement>('[data-pw-meter]');
  const word = meter?.querySelector<HTMLElement>('.pw-word');
  const rules: Record<string, (p: string) => boolean> = {
    len: p => p.length >= 8,
    letter: p => /[A-Za-z]/.test(p),
    digit: p => /\d/.test(p),
    extra: p => /[^A-Za-z0-9]/.test(p) || p.length >= 12,
    match: p => Boolean(p) && confirm?.value === p,
  };
  const update = () => {
    const p = input.value;
    const met: Record<string, boolean> = {};
    box.querySelectorAll<HTMLElement>('[data-rule]').forEach(li => {
      const ok = met[li.dataset.rule!] = rules[li.dataset.rule!]?.(p) ?? false;
      li.classList.toggle('met', ok);
      const state = li.querySelector('.pw-state');
      if (state) state.textContent = ok ? 'Done: ' : 'Still needed: ';
    });
    if (!meter || !word) return;
    meter.hidden = false;
    const level = !p ? 0 : met.len && met.letter && met.digit ? (met.extra ? 3 : 2) : 1;
    meter.dataset.level = String(level);
    word.textContent = ['Strength', 'Strength: weak', 'Strength: fair', 'Strength: strong'][level]!;
  };
  input.addEventListener('input', update);
  confirm?.addEventListener('input', update);
  update();
});

// Sign in with SSO, prefilled with "@yourcharity.org" from last time: the cursor starts before the @.
document.querySelectorAll<HTMLInputElement>('input[data-caret-start]').forEach(i => {
  if (!i.value.startsWith('@')) return;
  i.focus();
  i.setSelectionRange(0, 0);
});
